import { datadogLogInfo } from 'util/datadogLogs';
import {
  trackBingEvent,
  trackEvent,
  trackGoogleConversionCompanyCreation,
  trackGoogleConversionOwnerSignUp,
  trackLinkedInSignUp,
  trackUxEvent,
} from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import {
  amplitudeIdentify,
  amplitudeSetUserId,
} from 'util/trackingModules/amplitude';

export const userPayload = ({ fullName, email, password, phone }) => {
  const [firstName, ...lastName] = fullName.trim().split(' ');
  return {
    first_name: firstName,
    last_name: lastName.join(' '),
    email,
    password,
    phone,
  };
};

export const createBusinessTracking = ({
  company: company_resp,
  location: { id: locationId, state, zip, country_code, city },
  user: { id: userId, email, first_name, last_name, phone },
  uxTrackingData,
  amplitudeGroupIdentifyData,
  client_ip_address,
  isPayrollFirstSignup = false,
}) => {
  window.Homebase.uxTrackingData = uxTrackingData;
  const idParams = {
    company_id: company_resp.id || 'NA',
    event_id: company_resp.uuid || 'NA',
    location_id: locationId || 'NA',
  };

  const extraParams = {
    st: state || 'NA',
    zp: zip || 'NA',
    country: country_code || 'NA',
    ct: city || 'NA',
    client_ip_address: client_ip_address || 'NA',
    external_id: company_resp.uuid || 'NA',
  };

  const userData = {
    email: email || 'NA',
    first_name: first_name || 'NA',
    last_name: last_name || 'NA',
    phone: phone || 'NA',
  };
  amplitudeSetUserId(userId);
  amplitudeIdentify({ ...amplitudeGroupIdentifyData });

  datadogLogInfo({
    message: `Owner Sign Up before trackUxEvent`,
    context: {
      ...userData,
      ...extraParams,
      event_id: company_resp.uuid || 'NA',
    },
  });

  trackUxEvent({
    eventAction: EVENT_ACTIONS.OWNER_SIGN_UP,
    productArea: PRODUCT_AREAS.ONBOARDING,
    eventCategory: EVENT_CATEGORIES.ONBOARDING,
    actionType: TRACK_ACTION_TYPES.VIEW,
    properties: {
      ...userData,
      ...extraParams,
      event_id: company_resp.uuid || 'NA',
      ...(isPayrollFirstSignup ? { sign_up_version: 'payroll_first' } : {}),
    },
  });

  datadogLogInfo({
    message: `Owner Signed Up before trackEvent`,
    context: {
      ...idParams,
      ...userData,
      ...extraParams,
    },
  });

  // Old event naming convention required here to
  // keep parity with existing GA flow
  trackEvent(
    'Owner Signed Up',
    {
      ...idParams,
      ...userData,
      ...extraParams,
    },
    {
      ga: true,
      fb: true,
    }
  );

  trackEvent(
    'Company Created',
    {
      company_id: company_resp.id,
      event_id: company_resp.uuid,
      ...userData,
    },
    {
      ga: true,
      fb: true,
    }
  );

  // Both "Company..." and "Location..." required separately
  trackGoogleConversionCompanyCreation(company_resp);
  trackGoogleConversionOwnerSignUp();
  trackBingEvent('owner-signup');
  trackLinkedInSignUp();
};
